import { Component, NgZone } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MobileAwareComponent } from '../../common/mobile-aware/mobile-aware.component';
import { Contest } from '../../model/contest/Contest';
import {
  ContestEnrolData,
  ContestEnrolModalComponent,
  ContestEnrolResultData
} from '../contest-enrol-modal/contest-enrol-modal.component';
import {
  ContestPaymentData,
  ContestPaymentModalComponent
} from '../contest-payment-modal/contest-payment-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventType, TrackingService } from '../../service/tracking.service';
import { Role } from '../../model/auth/Role';
import { EnrolData } from '../../model/auth/User';
import {
  ContestPaymentConfirmData,
  ContestPaymentConfirmModalComponent,
  ContestPaymentConfirmResultData
} from '../contest-payment-confirm-modal/contest-payment-confirm-modal.component';
import { SchoolBaseDto } from '../../model/location/School';

@Component({
  selector: 'app-contest-enrollment-aware',
  template: '',
  styles: ['']
})
export class ContestEnrollmentAwareComponent extends MobileAwareComponent {

  protected dialogRef: MatDialog;
  private paymentModal?: MatDialogRef<ContestPaymentModalComponent>;
  private ngZone: NgZone;

  protected competitionId: string | undefined;

  constructor(private trackingService: TrackingService,
              ngZone: NgZone,
              breakpointObserver: BreakpointObserver,
              dialogRef: MatDialog) {
    super(breakpointObserver);

    this.dialogRef = dialogRef;
    this.ngZone = ngZone;
  }

  enrolForContest(contest: Contest, userId?: string, role?: Role, freeEnrolAllowed = false) {
    const data: ContestEnrolData = {
      title: contest.name,
      contest: contest,
      userId: userId,
      role: role,
      freeEnrolAllowed: freeEnrolAllowed
    };
    this.dialogRef.open(ContestEnrolModalComponent, {
      width: '600px',
      data: data
    }).afterClosed().subscribe((data: ContestEnrolResultData) => {
      if (data && (data.paymentPageUrl || data.exemptEnrol)) {
        this.payForContest(data.paymentPageUrl, data.exemptEnrol);
      } else if (data && data.freeEnrolRequested) {
        this.payForContest(undefined, false, true, userId, contest, role);
      } else if (data && data.freeEnrol && this.competitionId) {
        this.contestsListUpdated(this.competitionId);
      }
    });
  }

  enrolGroupForContest(contest: Contest, group: EnrolData[], freeEnrolAllowed: boolean, role: Role, regionId: string, school?: SchoolBaseDto) {
    const data: ContestEnrolData = {
      title: contest.name,
      contest: contest,
      group: group,
      role: role,
      regionId: regionId,
      school: school,
      freeEnrolAllowed: freeEnrolAllowed
    };
    this.dialogRef.open(ContestEnrolModalComponent, {
      width: '600px',
      data: data
    }).afterClosed().subscribe((data: ContestEnrolResultData) => {
      if (data?.paymentPageUrl) {
        this.payForContest(data.paymentPageUrl);
      } else if (data?.freeEnrolRequested) {
        this.payForContest(undefined, false, true, undefined, contest, undefined, group);
      } else if (data?.exemptEnrol) {
        this.payForContest(undefined, true, false, undefined, contest, undefined, group);
      }
    });
  }

  payForContest(paymentPageUrl?: string, exemptEnrol = false, freeEnrol = false,
                userId?: string, contest?: Contest, role?: Role, group?: EnrolData[]) {
    if (!exemptEnrol && !freeEnrol) {
      // @ts-ignore
      window.confirmPaymentCompleted = this.confirmPaymentCompleted.bind(this);
    }

    if (freeEnrol && !contest && (!group || !group.length)) return;

    if (!exemptEnrol) {
      this.trackingService.sendEvent(EventType.begin_checkout, undefined, freeEnrol ? 'free' : 'payment');
    }

    const data: ContestPaymentData = {
      paymentPageUrl: paymentPageUrl,
      exemptEnrol: exemptEnrol,
      freeEnrol: freeEnrol,

      userId: userId,
      contest: contest,
      role: role,

      group: group
    };
    this.paymentModal = this.dialogRef.open(ContestPaymentModalComponent, {
      width: '600px',
      height: exemptEnrol || freeEnrol ? '' : '700px',
      disableClose: true,
      data: data
    });
    this.paymentModal.afterClosed().subscribe((data: ContestEnrolData) => {
      if (data && data.contest) {
        this.contestsListUpdated(this.competitionId || '');
      }
    });
  }

  checkPaymentStatus(contestId: string, userId?: string, role?: Role, groupId?: string) {
    const data: ContestPaymentConfirmData = {
      contestId: contestId,
      userId: userId,
      role: role,
      groupId: groupId
    };
    this.dialogRef.open(ContestPaymentConfirmModalComponent, {
      width: '600px',
      data: data
    }).afterClosed().subscribe((data: ContestPaymentConfirmResultData) => {
      if (data && data.statusChanged) {
        this.contestsListUpdated(this.competitionId || '');
      }
    });
  }

  confirmPaymentCompleted() {
    // @ts-ignore
    delete window.confirmPaymentCompleted;

    this.ngZone.run(() => {
      if (this.paymentModal) {
        this.paymentModal.close();
      }

      if (this.competitionId) {
        this.contestsListUpdated(this.competitionId);
      }
    });
  }

  protected contestsListUpdated(competitionId: string) {
    // should be overridden in children
  }

}
